function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPage = function SvgPage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M42,19H6V9c0-1.657,1.343-3,3-3h30c1.657,0,3,1.343,3,3V19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBDEFB"
    },
    d: "M6,16h36v23c0,1.657-1.343,3-3,3H9c-1.657,0-3-1.343-3-3V16z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8BC34A"
    },
    cx: 11,
    cy: 11,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFEB3B"
    },
    cx: 17,
    cy: 11,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M39,12c0,0.553-0.447,1-1,1H23c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1h15c0.553,0,1,0.447,1,1  V12z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 19,
    style: {
      fill: "#90CAF9"
    },
    width: 17,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 33,
    style: {
      fill: "#90CAF9"
    },
    width: 17,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 19,
    style: {
      fill: "#90CAF9"
    },
    width: 10,
    height: 20
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/page.7a6656f0.svg";
export { ForwardRef as ReactComponent };